import { Injectable, Inject, signal } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class AppStateService {
    userData = signal<any>(null);   // store API response
    highLevelCategoryData = signal<any>(null);

    private countriesSubject = new BehaviorSubject<any[]>([]);
    countries$ = this.countriesSubject.asObservable();

    private categoryData = new BehaviorSubject<any[]>([]);
    categoryData$ = this.categoryData.asObservable();

    setUserData(data: any) {
        this.userData.set(data);
    }

    setHighLevelCategoryData(data: any) {
        this.highLevelCategoryData.set(data);
    }

    setCategoryData(data: any) {
        this.categoryData.next(data);
    }

    setCountries(countries: any[]) {
        this.countriesSubject.next(countries);
    }
}